import { Box, BoxProps, ColorOptions, Icon, Loader, ModBox } from '@jfs/ui-new'
import { TextInputNew } from '../AdminInputs'
import { FC, useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../data/store'
import { DropdownOptimised } from '../DropdownNew'
import { DropdownTypes } from '../DropdownNew/types'

interface ActionMenuSearchBy {
  type:
    | 'global'
    | 'checker'
    | 'maker'
    | 'fiuGlobal'
    | 'fiuMaker'
    | 'aadharRedactionChecker'
    | 'aadharRedactionMaker'
    | 'entity'
}
export const dropDownData = [
  { id: '1', value: 'Application ID' },
  // { id: '2', value: 'Mobile Number' },
  { id: '3', value: 'Entity Name' },
]

export const dropDownAppIdOnly = [{ id: '1', value: 'Application ID' }]

const getKeyFromValue = (key: string) => {
  const obj = {
    'Application ID': 'applicationId',
    // 'Mobile Number': 'mobileNumber',
    'Entity Name': 'entityName',
  }
  return obj[key]
}

const ActionMenuSearchBy: FC<ActionMenuSearchBy> = ({ type }: ActionMenuSearchBy) => {
  const {
    searchGlobalCheckerListBy,
    fetchMakerListReq,
    fetchMyCheckerList,
    userName,
    searchAadharRedactionCheckerList,
    fetchAadharRedactionMakerListReq,
    fetchFiuMakerList,
    fetchFiuCheckerList,
  } = useStores((store) => ({
    searchGlobalCheckerListBy: store.getGlobalCheckerList,
    fetchMakerListReq: store.fetchMakerList,
    fetchMyCheckerList: store.getMyCheckerList,
    userName: store.user.name,
    searchAadharRedactionCheckerList: store.getAadharRedactionGlobalCheckerList,
    fetchAadharRedactionMakerListReq: store.fetchAadharRedactionMakerList,
    fetchFiuMakerList: store.fetchFiuMakerList,
    fetchFiuCheckerList: store.fetchFiuCheckerList,
  }))

  const [fetchGlobalList, fetchGlobalHandler] = useLazyApiData(searchGlobalCheckerListBy)
  const [fetchMakerList, fetchMakerHandler] = useLazyApiData(fetchMakerListReq)
  const [mfetchFiuMakerList, fetchFiuMakerListHandler] = useLazyApiData(fetchFiuMakerList)
  const [fetchCheckerList, fetchCheckerHandler] = useLazyApiData(fetchMyCheckerList)
  const [fetchAadharRedactionGlobalList, fetchAadharRedactionCheckerHandler] = useLazyApiData(
    searchAadharRedactionCheckerList,
  )
  const [fetchAadharRedactionMakerList, fetchAadharRedactionMakerHandler] = useLazyApiData(
    fetchAadharRedactionMakerListReq,
  )
  const [lazyFetchFiuCheckerList, fetchFiuCheckerListHandler] = useLazyApiData(fetchFiuCheckerList)

  const [searchString, setSearchString] = useState('')
  const [placeHolder, setPlaceholder] = useState('Search with Application ID')
  // const [searchLength, setSearchLength] = useState(3)
  // const [cancel, setCancel] = useState(false)
  const [error, setError] = useState('')
  const [isLoading, setLoading] = useState(false)
  const [isSearchDone, setSearchDone] = useState(false)

  const [value, setValue] = useState('Application ID')

  useEffect(() => {
    if (
      fetchGlobalHandler?.state === 'fulfilled' ||
      fetchGlobalHandler?.state === 'rejected' ||
      fetchFiuCheckerListHandler?.state === 'fulfilled' ||
      fetchFiuCheckerListHandler?.state === 'rejected' ||
      fetchMakerHandler?.state === 'fulfilled' ||
      fetchMakerHandler?.state === 'rejected' ||
      fetchCheckerHandler?.state === 'fulfilled' ||
      fetchCheckerHandler?.state === 'rejected' ||
      fetchAadharRedactionCheckerHandler?.state === 'fulfilled' ||
      fetchAadharRedactionCheckerHandler?.state === 'rejected' ||
      fetchAadharRedactionMakerHandler?.state === 'fulfilled' ||
      fetchAadharRedactionMakerHandler?.state === 'rejected' ||
      fetchFiuMakerListHandler?.state === 'fulfilled' ||
      fetchFiuMakerListHandler?.state === 'rejected'
    ) {
      setLoading(false)
      setSearchDone((prev) => !prev)
    }
  }, [
    fetchAadharRedactionCheckerHandler?.state,
    fetchAadharRedactionMakerHandler?.state,
    fetchCheckerHandler?.state,
    fetchFiuMakerListHandler?.state,
    fetchGlobalHandler?.state,
    fetchMakerHandler?.state,
    fetchFiuCheckerListHandler?.state,
  ])

  const onChangeText = (text: string) => {
    setSearchString(text)
    setSearchDone(false)
  }

  const onDropDownChange = (value: string) => {
    setValue(value)
    const getPlaceHolder: any = {
      'Application ID': 'Search with Application ID',
      // 'Mobile Number': 'Search with Mobile Number',
      'Entity Name': 'Search with Entity Name',
    }
    // const getSearchLength: any = {
    //   'Application ID': 3,
    //   'Mobile Number': 10,
    //   'Entity Name': 3,
    // }
    const str = getPlaceHolder[value] ?? 'Search'
    setPlaceholder(str)
    setSearchString('')
    // const sLength = getSearchLength[value]
    // setSearchLength(sLength)
  }
  const isValidEntry = searchString.length >= 3

  const onSearchPress = () => {
    if (isValidEntry) {
      if (isLoading) {
        setLoading(false)
        setError('')
        setSearchString('')
        if (type === 'global') {
          fetchGlobalList()
        } else if (type === 'checker') {
          fetchCheckerList(userName)
        } else if (type === 'maker') {
          fetchMakerList()
        } else if (type === 'fiuGlobal') {
          lazyFetchFiuCheckerList('', '')
        } else if (type === 'fiuMaker') {
          mfetchFiuMakerList('', '')
        } else if (type === 'aadharRedactionChecker') {
          fetchAadharRedactionGlobalList('', '')
        } else if (type === 'aadharRedactionMaker') {
          fetchAadharRedactionMakerList('', '')
        }
        setSearchDone(false)
      } else {
        if (!isSearchDone) {
          setLoading(true)
          setError('')
          if (type === 'global') {
            fetchGlobalList(getKeyFromValue(value), searchString)
          } else if (type === 'checker') {
            fetchCheckerList(userName, getKeyFromValue(value), searchString)
          } else if (type === 'maker') {
            fetchMakerList(getKeyFromValue(value), searchString)
          } else if (type === 'fiuGlobal') {
            lazyFetchFiuCheckerList(getKeyFromValue(value), searchString)
          } else if (type === 'fiuMaker') {
            mfetchFiuMakerList(getKeyFromValue(value), searchString)
          } else if (type === 'aadharRedactionChecker') {
            fetchAadharRedactionGlobalList(getKeyFromValue(value), searchString)
          } else if (type === 'aadharRedactionMaker') {
            fetchAadharRedactionMakerList(getKeyFromValue(value), searchString)
          }
        } else {
          setLoading(false)
          setError('')
          setSearchString('')
          if (type === 'global') {
            fetchGlobalList('', '')
          } else if (type === 'checker') {
            fetchCheckerList(userName, '', '')
          } else if (type === 'maker') {
            fetchMakerList('', '')
          } else if (type === 'fiuGlobal') {
            lazyFetchFiuCheckerList('', '')
          } else if (type === 'fiuMaker') {
            mfetchFiuMakerList('', '')
          } else if (type === 'aadharRedactionChecker') {
            fetchAadharRedactionGlobalList('', '')
          } else if (type === 'aadharRedactionMaker') {
            fetchAadharRedactionMakerList('', '')
          }
        }
      }
    } else {
      if (isSearchDone) {
        setLoading(false)
        setError('')
        setSearchString('')
        if (type === 'global') {
          fetchGlobalList('', '')
        } else if (type === 'checker') {
          fetchCheckerList(userName, '', '')
        } else if (type === 'maker') {
          fetchMakerList('', '')
        } else if (type === 'fiuGlobal') {
          lazyFetchFiuCheckerList('', '')
        } else if (type === 'fiuMaker') {
          mfetchFiuMakerList('', '')
        } else if (type === 'aadharRedactionChecker') {
          fetchAadharRedactionGlobalList('', '')
        } else if (type === 'aadharRedactionMaker') {
          fetchAadharRedactionMakerList('', '')
        }
      }
    }
  }

  return (
    <Box {...styles.textInputContainer}>
      <ModBox show={true} {...styles.mobileSelectionFix}>
        <DropdownOptimised
          testID="searchByDropdown"
          placeHolder={placeHolder}
          onChange={onDropDownChange}
          data={type === 'global' || type === 'checker' || type === 'maker' ? dropDownData : dropDownAppIdOnly}
          value={value}
          type={DropdownTypes.DEFAULT_WITHOUT_BORDER}
          hide={false}
        />
      </ModBox>
      <ModBox {...styles.rightContainer}>
        <TextInputNew
          textWidth={200}
          placeholder={placeHolder}
          value={searchString}
          onChangeText={onChangeText}
          focusBorderColor={'TRANSPARENT'}
          labelFontFamily={'jiotype-medium'}
          fontSize={12}
          paddingHorizontal={8}
        />
        <ModBox show={isLoading}>
          <Loader color={'PRIMARY'} type={16} />
        </ModBox>
        <ModBox onPress={onSearchPress} {...styles.iconContainer(true)} show={!isLoading}>
          <Icon id={isSearchDone ? 'CLOSE' : 'SEARCH'} color={'PRIMARY'} size={20} />
        </ModBox>
      </ModBox>
    </Box>
  )
}

export { ActionMenuSearchBy }

const styles = {
  textInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    // borderColor: '#E0E0E0' as ColorOptions,
    // borderRadius: 4,
    // borderWidth: 1,
    // bg: 'WHITE',
  } as BoxProps,
  rightContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    borderColor: '#E0E0E0' as ColorOptions,
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    borderWidth: 1,
    h: 36,
    maxWidth: 260,
  } as BoxProps,
  loadingContainer: { f: 1, flexDirection: 'row', justify: 'center', align: 'center', ph: 4 } as BoxProps,
  iconContainer: (isValid: boolean) =>
    ({
      h: 36,
      w: 36,
      underlayColor: 'TRANSPARENT',
      borderTopLeftRadius: 2,
      borderBottomLeftRadius: 2,
      borderTopRightRadius: 2,
      borderBottomRightRadius: 2,
      justify: 'center',
      disabled: !isValid,
      align: 'center',
    } as BoxProps),
  mobileSelectionFix: {
    marginRight: 0,
    display: 'flex',
    borderWidth: 1,
    flexWrap: 'wrap',
    flexDirection: 'row',
    borderColor: '#E0E0E0' as ColorOptions,
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
  } as BoxProps,
}
